module.exports = __webpack_public_path__ + "static/media/Medicham_gaussian2.c9adf908.png";